<template>
  <el-dialog title="标记知识点" :visible.sync="visible" :append-to-body="true" width="600px" class="markPointDialog"
             :before-close="handleClose">
    <el-form ref="markKnowledgeFrom" :model="formData" label-width="125px" :inline="true">
      <el-form-item label="知识点名称：">
        <el-input v-model="formData.name" type="text" placeholder="知识点名称" maxlength="10" class="nameinput"
                  show-word-limit
                  clearable/>
        <span class="tip">字数不超过10</span>
      </el-form-item>
      <el-form-item label="知识点开始时间：">
        <div class="left">
          <el-input-number size="small" class="timeInput" v-model.number="formData.startTime.h1"
                           controls-position="right"
                           maxLength="1"
                           readonly
                           :min="0" :max="9"></el-input-number>
          <el-input-number size="small" class="timeInput" v-model.number="formData.startTime.h2"
                           controls-position="right"
                           :min="0" :max="9"></el-input-number>
          :
          <el-input-number size="small" class="timeInput" v-model.number="formData.startTime.m1"
                           controls-position="right"
                           :min="0" :max="5"></el-input-number>
          <el-input-number size="small" class="timeInput" v-model.number="formData.startTime.m2"
                           controls-position="right"
                           :min="0" :max="9"></el-input-number>
          :
          <el-input-number size="small" class="timeInput" v-model.number="formData.startTime.s1"
                           controls-position="right"
                           :min="0" :max="5"></el-input-number>
          <el-input-number size="small" class="timeInput" v-model.number="formData.startTime.s2"
                           controls-position="right"
                           :min="0" :max="9"></el-input-number>
        </div>

        <span class="tip">例如：00:00:25</span>
      </el-form-item>
      <el-form-item label="知识点结束时间：">
        <div class="left">
          <el-input-number size="small" class="timeInput" v-model.number="formData.endTime.h1" controls-position="right"
                           maxLength="1"
                           :min="0" :max="9"></el-input-number>
          <el-input-number size="small" class="timeInput" v-model.number="formData.endTime.h2" controls-position="right"
                           :min="0" :max="9"></el-input-number>
          :
          <el-input-number size="small" class="timeInput" v-model.number="formData.endTime.m1" controls-position="right"
                           :min="0" :max="5"></el-input-number>
          <el-input-number size="small" class="timeInput" v-model.number="formData.endTime.m2" controls-position="right"
                           :min="0" :max="9"></el-input-number>
          :
          <el-input-number size="small" class="timeInput" v-model.number="formData.endTime.s1" controls-position="right"
                           :min="0" :max="5"></el-input-number>
          <el-input-number size="small" class="timeInput" v-model.number="formData.endTime.s2" controls-position="right"
                           :min="0" :max="9"></el-input-number>
        </div>
        <span class="tip">例如：00:00:25</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="submitMark">提 交</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import { $Cookies } from '@/utils';
  import { markPoint } from '@/api/resourceDetail';

  export default {
    name: 'MarkPoint',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      rscId: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        formData: {
          name: '',
          startTime: {
            h1: 0,
            h2: 0,
            m1: 0,
            m2: 0,
            s1: 0,
            s2: 0
          },
          endTime: {
            h1: 0,
            h2: 0,
            m1: 0,
            m2: 0,
            s1: 0,
            s2: 0
          }
        },
      };
    },
    methods: {
      handleClose () {
        this.$emit('close');
      },
      formatTimeStr (data) {
        return String(data[ 'h1' ]) + data[ 'h2' ] + ':' + data[ 'm1' ] + data[ 'm2' ] + ':' + data[ 's1' ] + data[ 's2' ];
      },
      submitMark () {
        if (!this.formData.name.trim()) {
          this.$message.error('知识单名称不能为空');
          return false;
        }

        let sTime = '', eTime = '', stTime = '', etTime = '';
        for (const key in this.formData.startTime) {
          sTime += this.formData.startTime[ key ];

        }
        for (const key in this.formData.endTime) {
          eTime += this.formData.endTime[ key ];
        }
        sTime = Number(sTime);
        eTime = Number(eTime);
        if (sTime === eTime) {
          this.$message.error('知识点开始时间不能与结束时间相同');
          return false;
        }
        if (sTime > eTime) {
          this.$message.error('知识点结束时间不能小于开始时间');
          return false;
        }
        stTime = this.formatTimeStr(this.formData.startTime);
        etTime = this.formatTimeStr(this.formData.endTime);
        const uid = $Cookies.get('uid');
        const params = {
          userNo: Number(uid),
          partName: this.formData.name,
          rscID: this.rscId,
          startTime: stTime,
          endTime: etTime
        };
        markPoint(params).then(data => {
          if (data.success) {
            this.$message({
              type: 'success',
              message: '标记知识点成功！',
              duration: 1500,
              onClose: () => {
                this.$emit('markSuccess');
                this.formData = {
                  name:'',
                  startTime: {
                    h1: 0,
                    h2: 0,
                    m1: 0,
                    m2: 0,
                    s1: 0,
                    s2: 0
                  },
                  endTime: {
                    h1: 0,
                    h2: 0,
                    m1: 0,
                    m2: 0,
                    s1: 0,
                    s2: 0
                  }
                }
              }
            });
          } else {
            this.$message.error(data.errorMsg);
          }
        });
      }
    }
  };
</script>
<style lang="scss">
  @import "@/assets/css/mixins.scss";

  .markPointDialog {
    .el-form-item {
      width: 100%;

      .el-form-item__content {
        width: calc(100% - 125px);
        @include clearfix;

        .left {
          @include fl;
        }

        .nameinput {
          @include fl;
          width: 67%;
        }

        .tip {
          color: #a8a8a8;
          @include fr;
        }
      }
    }

    .timeInput {
      width: 43px;

      .el-input-number__decrease {
        width: 15px;
      }

      .el-input-number__increase {
        width: 15px;
      }

      .el-input {
        input {
          padding: 0;
          text-align: left;
          text-indent: 10px;
        }
      }
    }

    .dialog-footer {
      text-align: center;
    }
  }
</style>
